<template>
    <v-container>
        <v-layout wrap justify-center align-start>

            <v-flex xs12>
                <w-main-title title="Planes" :breadcrumbs="breadcrumbs"></w-main-title>
            </v-flex>

            <v-flex xs12 text-xs-center text-md-right>
              <v-btn color="secondary" round @click="createCoupon">
                <v-icon class="mr-2" size="14">fa-plus</v-icon>
                Crear cupon
              </v-btn>
            </v-flex>

            <v-flex xs12 pa-2 text-xs-center>
              <v-progress-linear indeterminate height="2" color="primary" v-if="loading" />
              <v-slide-y-transition>
                <div v-show="!loading">
                  <coupon-list internal :coupons="items" @click:edit="editCoupon" />
                </div>
              </v-slide-y-transition>
            </v-flex>

          <coupon-editor ref="couponEditor" @saved="getCoupons" @deleted="getCoupons"/>

        </v-layout>
    </v-container>
</template>

<script>
    import WMainTitle from '@/components/common/WMainTitle'

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'
    import CouponList from "@/components/admin/coupons/CouponList";
    import CouponEditor from "@/components/admin/coupons/CouponEditor";

    export default{
        components: {
          CouponEditor,
          CouponList,
          WMainTitle
        },
        data(){
          return {

            loading: true,

            defaultPlan: null,
            items: [],
            moreItemsLink: null,

            breadcrumbs: [
              {
                text: 'Administrador',
                disabled: true,
                to: '/'
              },
              {
                text: 'Cupones',
                disabled: true,
                to: ''
              },
            ]
          }
        },
        created(){},
        mounted(){
          const vm = this
          vm.getCoupons()
        },
        methods: {
            editCoupon(coupon){
              const vm = this
              vm.$refs.couponEditor.show(coupon)
            },
            createCoupon(){
              const vm = this
              vm.defaultPlan = null
              vm.$nextTick(function(){
                vm.$refs.couponEditor.show()
              })
            },
            debouncedGetCoupons: debounce(function(){
                this.getCoupons()
            }, 500),
            clearSearch(){
                this.search = ''
                this.applyFilters()
            },
            async getCoupons(url = ''){

                const vm = this

               let filters = {}

                vm.loading = true
                const response = url ? await ApiUtils.makeGet(url) :
                        await ApiUtils.makeGet('subscriptions/coupons', filters)
                vm.loading = false

                if (!response.ok) {
                    const json = await response.json()
                    const message = json.message || 'Error intentando cargar coupones'
                    vm.toast(message, 'error')
                    return
                }

                const json = await response.json()
                if(url){
                  vm.items = [...vm.items, ...json.result.coupons.data]
                }else{
                  vm.items = json.result.coupons.data
                }

                vm.moreItemsLink = json.result.coupons.next_page_url

            }
        },

        watch: {},
        computed: {}
    }
</script>

<style scoped>

    .account-btn{
        position: absolute;
        left: 60px;
        top: 80px;
        width: 35px;
        height: 35px;
        font-size: 14px;
        z-index: 10;
    }

    .flex-center {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    >>>.sticky-filters {
        position: fixed !important;
        top: 4px;
    }

    .specialist-wrapper {
        position: relative;
        background-color: rgba(255, 255, 255, .7);
        transition: .1s all
    }

    .specialist-wrapper:hover {
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.3);
        transform: scale(1.01)
    }

    .bg-blur {
        background-size: cover;
        background-attachment: fixed;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -2;
        opacity: .7;
    }

    .fixed-bg-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: .95;
        z-index: -1;
        pointer-events: none;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#7db9e8+0,1e5799+36 */
        background: rgb(125, 185, 232); /* Old browsers */
        background: -moz-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7db9e8', endColorstr='#1e5799', GradientType=0); /* IE6-9 */
    }


</style>